export default {
  leftCol: {
    notCollect: "Emblem ne collecte aucune donnée pendant ce processus",
    proofOfAge: "Votre preuve d'âge ne permet à personne de retracer votre activité en ligne",
  },
  rightColIntro: {
    title: "Verification de l'age",
    poweredBy: "alimenté par",
    stateLaw: "La loi française vous oblige à vérifier que vous avez 18 ans ou plus",
    emblemPartner: "Nous avons collaboré avec Emblem, un système fiable de vérification de l'âge.",
    safeSimple: "C'est sûr, simple et requis une seule fois.",
    verifyNow: "Vérifiez maintenant",
    alreadyVerified: "Déjà vérifié ?",
    login: "Se connecter",
  },
  rightColQR: {
    switchToMobile: "Passer à un appareil mobile",
    verificationRequires: "La vérification nécessite un appareil mobile",
    howToContinue: "Comment continuer",
    one: "1. Ouvrez l'appareil photo sur votre appareil mobile.",
    two: "2. Scannez le code QR.",
    three: "3. Suivez les étapes sur votre écran."
  }
}